import { TKeys } from './types'

export const pl_pl: Record<TKeys, string> = {
    ...require('./en-en').en_en, // TODO
    // SCREENS
    // General
    loading: 'Ładowanie...',
    // SignIn
    signin_title: 'Zaloguj się',
    signin_redirect_title: 'Zweryfikuj swój login i hasło',
    psw_placeholder_redirect: 'Potwierdź hasło',
    psw_placeholder: 'Wprowadź hasło',
    email_placeholder: 'Adres e-mail',
    language: 'Język',
    forgot_password: 'Zapomniałeś hasła?',
    signup_hint: 'Nie masz konta? Zarejestruj się',
    btn_signin: 'Zaloguj się',
    // Intro
    // N-Ary sort
    my_profile: 'Moje preferencje',
    btn_submit: 'Prześlij',
    btn_finish: 'Zakończ',
    hint_undo: 'Czy na pewno chcesz cofnąć swoją ostatnią czynność?',
    // Global screen
    tip_quit: 'Czy na pewno chcesz wyjść?',
    // State screen // Tell us, what is your ideal work environment?
    intro_title: 'Szczęście jest kluczem do sukcesu',
    intro_body: `Jeśli kochasz to, co robisz, i zespół, z którym pracujesz, osiągniesz sukces w życiu zawodowym.`,
    howto1_title: `Zobaczysz 2 stwierdzenia
    
    Kliknij na to, które preferujesz

    Zajmie to tylko 12 minut.`,
    howto1_body: 'Powinieneś wykonać ten test w cichym środowisku.',
    award1_title: 'Dobrze zrobione!',
    award1_body: `Na górze poniższej listy znajdziesz to, co uważasz za najważniejsze w Twoim idealnym środowisku pracy. Jeśli chcesz, możesz zmienić kolejność stwierdzeń, przeciągając i upuszczając je.`,
    award2_title: 'Jesteś już ponad połowę drogi!',
    award2_body: `Poczuj dreszczyk emocji, gdy będziesz je przestawiać według własnego uznania, po prostu przeciągając i upuszczając Twoje wymarzone miejsce pracy jest już tylko krok dalej!!`,
    award3_title: 'Gratulacje za trzecią część',
    award3_body: `Jesteś już prawie na miejscu Linia mety jest na wyciągnięcie ręki Weź głęboki oddech, daj z siebie wszystko w tych ostatnich chwilach, i świętuj niesamowite osiągnięcie, które na Ciebie czeka. Dajesz radę Skończ mocno, i pozwól, aby historia sukcesu się rozwinęła!`,
    howto2_title: 'A teraz ostatnie pytania - ±2 minut',
    howto2_body: `Zostaniesz poproszony o kilka dodatkowych pytań. Będziesz musiał wybrać najlepsze lub najgorsze spośród niektórych stwierdzeń, które już wcześniej uszeregowałeś. Pozwoli nam to połączyć wszystkie trzy rundy Twojej osobowości`,
    title_rank: 'W moim **IDEALNYM** środowisku pracy,',
    subtitle_rank_2: 'najważniejsze jest ...',
    subtitle_rank_n: 'Gdzie umieściłbyś następujące stwierdzenie?',
    hint_reorder: 'Uporządkuj w razie potrzeby, od najważniejszego do najmniej ważnego',
    hint_overview: 'Kliknij poniżej, aby zobaczyć podsumowanie',
    hint_profile: 'Moje bieżące preferencje',
    hint_place_below: 'Umieść stwierdzenie poniżej',
    title_rank_bucket: 'Ostatnie porównania',
    subtitle_rank_best: 'Tym razem, które jest dla Ciebie NAJWAŻNIEJSZE?',
    subtitle_rank_least: 'Które jest dla Ciebie NAJMNIEJ ważne?',
    subtitle_rank_reorder: 'Uporządkuj od NAJWAŻNIEJSZEGO do NAJMNIEJ ważnego',
    title_thanks: 'Dobrze zrobione!',
    hint_thanks: 'Twoje preferencje zostały pomyślnie przesłane',
    title_error: 'Nie możemy wysłać Twoich danych',
    hint_error: 'Spróbuj ponownie później ...',
    hint_error_validation: 'Wystąpił błąd walidacji, spróbuj później',
    hint_error_dup: 'Już przesłałeś poprzedni raport.',
    hint_confirm_round: 'Czy na pewno chcesz potwierdzić ten ranking?',
    retry_btn: 'Próba',
    btn_to_overview: 'PRZEGLĄD',
    btn_to_bucket_x: 'KOSZ',
    btn_to_params: 'PARAMETRY',
    btn_open: 'OTWÓRZ',
    btn_start: 'START',
    btn_confirm: 'POTWIERDŹ',
    // btn_next: 'NEXT',
    btn_next: '>',
    btn_next_str: 'NASTĘPNY',
    btn_next_round: 'NASTĘPNA RUNDA',
    // btn_prev: 'PREV',
    btn_prev: '<',
    btn_cancel: 'ANULUJ',
    // btn_back: 'BACK',
    btn_back: '<',
    btn_download: 'Pobierz swój raport',
    btn_quit: 'WYJDŹ',
    // Comparisons
    pick_best: 'Które jest dla Ciebie NAJWAŻNIEJSZE?',
    pick_worst: 'Które jest dla Ciebie NAJMNIEJ ważne?',
    vs: 'LUB',
    // UI elements
    round: 'Runda',
    stm: 'Stwierdzenie',
    bucket: 'Kosz',
    axis_y: 'Liczba stwierdzeń',
    tip_saved: 'Zapisane',
    top_scale_hint: '**Najważniejsze**',
    bottom_scale_hint: '**Najmniej ważne**',
    pick_tip: 'Wybrane!',
    how_to_binary_title: 'Instrukcje',
    // values
    samen: 'Współpraca',
    conf: 'Ugodowość',
    erken: 'Uznanie',
    zorg: 'Troska',
    gelijk: 'Równość & różnorodność',
    zelfsturing: 'Autonomia',
    macht: 'Władza',
    voorspelbaar: 'Przewidywalność',
    prestatie: 'Wyniki',
    zelfontplooi: 'Rozwój osobisty',
    duurzaam: 'Zrównoważony rozwój',
    integriteit: 'Uczciwość',
    innovatie: 'Innowacja',
    daadkracht: 'Siła',
    //
    no_slug_error: 'Upewnij się, że podążasz za właściwym linkiem, jeśli tak, skontaktuj się z administratorem',
    unknown_error: 'Wystąpił nieznany błąd, spróbuj ponownie później',
    invalid_credentials: 'Nieprawidłowa kombinacja e-mail/hasło',
    // 360:
    // TLTM Scale
    lvl0: 'Wybierz',
    lvl1: 'Zdecydowanie za mało',
    lvl2: 'Za mało',
    lvl3: 'Raczej za mało',
    lvl4: 'Właściwa ilość',
    lvl5: 'Trochę za dużo',
    lvl6: 'Za dużo',
    lvl7: 'Zdecydowanie za dużo',
    lvlx1: '-3',
    lvlx2: '-2',
    lvlx3: '-1',
    lvlx4: 'Właściwa ilość',
    lvlx5: '+1',
    lvlx6: '+2',
    lvlx7: '+3',
    // SCALE 10 lvlSC10x
    lvlSC10x00: 'Wybierz',
    lvlSC10x00e: '🤔',
    //
    lvlSC10x0e: '😫',
    lvlSC10x0nps: 'Nigdy',
    lvlSC10x0: 'Brak',
    lvlSC10x1e: '😖',
    lvlSC10x1nps: 'MISSING',
    lvlSC10x1: 'Rendition',
    lvlSC10x2e: '😣',
    lvlSC10x2nps: 'MISSING',
    lvlSC10x2: 'Bardzo zły',
    lvlSC10x3e: '😠',
    lvlSC10x3nps: 'MISSING',
    lvlSC10x3: 'Źle',
    lvlSC10x4e: '🙁',
    lvlSC10x4nps: 'MISSING',
    lvlSC10x4: 'Niedostateczny',
    lvlSC10x5e: '😯',
    lvlSC10x5nps: 'MISSING',
    lvlSC10x5: 'Średni',
    lvlSC10x6e: '😐',
    lvlSC10x6nps: 'MISSING',
    lvlSC10x6: 'Średni',
    lvlSC10x7e: '🙂',
    lvlSC10x7nps: 'MISSING',
    lvlSC10x7: 'Dobrze',
    lvlSC10x8e: '😊',
    lvlSC10x8nps: 'MISSING',
    lvlSC10x8: 'Bardzo dobrze',
    lvlSC10x9e: '😃',
    lvlSC10x9nps: 'MISSING',
    lvlSC10x9: 'Wspaniały',
    lvlSC10x10e: '😍',
    lvlSC10x10nps: 'Z pewnością',
    lvlSC10x10: 'Bez błędu',
    howto_360_title: `Jako organizacja przywiązujemy dużą wagę do wartości, wierzymy, że ważne jest, aby wiedzieć, co sprawia, że jesteś naprawdę szczęśliwy w Twoim środowisku pracy.`,
    howto_360_body: `Ten kwestionariusz pozostanie anonimowy dla Twojej hierarchii, która otrzyma tylko zagregowane wyniki`,
    picker_360_title_workenv: 'W moim obecnym środowisku pracy,',
    picker_360_title_leadership: 'Mój bezpośredni przełożony …',
    nps_title: 'Czy poleciłbyś pracę tutaj komukolwiek, kogo znasz?',
    comment_title: 'Dodaj komentarz',
    comment_placeholder: 'Dziękujemy za jakiekolwiek konstruktive uwagi dotyczące tego stwierdzenia',
    comment_save: 'Zapisz i zamknij',
    comment_remaining: 'character(s) left',
    howto_workenv_title: 'And now, your work environment',
    howto_workenv_body: 'What about it ? Last questions, we promise!',
    howto_nps_title: '',
    howto_nps_body: '',
    // legacy_v2:
    btn_next_step: 'Dalej',
    to_assign: 'Do przypisania',
    least_important: 'Najmniej ważne',
    moderately_important: 'Umiarkowanie ważne',
    most_important: 'Najważniejsze',
    ranker_title: 'Co jest dla Ciebie ważne w idealnej pracy?',
    too_insufficient_warning: 'Ta grupa zawiera zbyt mało stwierdzeń',
    too_much_warning: 'Ta grupa zawiera zbyt wiele stwierdzeń',
    too_much_warning1: 'Przypisałeś zbyt wiele stwierdzeń do grupy (grup):',
    too_much_warning2: 'Kliknij na grupę i przenieś stwierdzenie(a) do innej grupy, aż rozkład będzie prawidłowy',
    empty_bin: 'Ta grupa jest pusta',
    // further_ranking: 'Proszę, uszereguj dodatkowo {{v1}} stwierdzenia, które oznaczyłeś jako "{{v2}}"',
    further_ranking: 'Co jest dla Ciebie ważne w idealnej pracy?',
    hint_modal_title: 'Wyobraź sobie swoją idealną przestrzeń do pracy',
    hint_modal_body1: 'Uporządkuj 42 stwierdzenia o swoim idealnym środowisku od najmniej do najbardziej ważnych',
    hint_modal_body2_left: 'lewa',
    hint_modal_body2_left_txt: '11 stwierdzeń, które uważasz za najmniej ważne',
    hint_modal_body2_right: 'prawa',
    hint_modal_body2_right_txt: '11 stwierdzeń, które uważasz za najważniejsze',
    hint_modal_body2_middle: 'środek',
    hint_modal_body2_middle_txt: '20 stwierdzeń, które uważasz za umiarkowanie ważne',
    hint_modal_body3: 'Przeciągnij i upuść każde stwierdzenie do grupy, która najlepiej do Ciebie pasuje',
    hint_modal_cta: 'Rozpocznij test',
    hint_top: 'Przewiń w górę',
    hint_down: 'Przewiń w dół',
    final_distribution_invalid_title: 'Ostateczny rozkład jest nieprawidłowy',
    final_distribution_invalid_body: 'Istnieje {{v1}} kosz(y) z zbyt wieloma oświadczeniami i {{v2}} kosz(y) z zbyt małą liczbą oświadczeń',
    no_available_bins_warning: 'Brak dostępnych koszy do losowego przydziału - wszystkie kosze osiągnęły maksymalną pojemność',
    sort_middle_bucket_title: 'Czy chcesz posortować środkowy kosz?',
    sort_middle_bucket_body: 'To posortuje środkowy kosz według wartości.',
    reflect_current_view_title: 'Czy to odzwierciedla Twój obecny pogląd?',
    reflect_current_view_sort_body: 'Jeśli nie, zostaniesz poproszony o posortowanie ostatecznego rankingu',
    yes: 'Tak',
    no: 'Nie',
    final_ranking: 'Ostateczny ranking',
    example: 'Przykład :',
}
